/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-ugc-待审稿件
 */
'use strict';
angular.module("reviewManuscriptModule", ["backArticleServiceModule"]).
controller('reviewManuscriptCtrl', ['$scope', 'httpService', '$q', '$timeout', 'modalDialog', 'backArticleService','$filter', function($scope, httpService, $q, $timeout, modalDialog, backArticleService,$filter) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
            inputData: '',
            channelsOptions: []
        }
        $scope.page = {
            "CURRPAGE": 0,
            "PAGESIZE": 20,
            "ITEMCOUNT": 0
        };
        $scope.allStatus = {
            '0': '草稿',
            '1': '待审核',
            '2': '二次审核',
            '3': '已签发',
            '4': '已退稿',
        };
        $scope.allStatusClass = {
        	'0': 'caogao',
            '1': 'daishenhe',
            '2': 'ercishenhe',
            '3': 'yiqianfa',
            '4': 'yituigao',
        }
        $scope.allType = {
            '0': '图文稿',
            '1': '图集稿',
            '2': '视频稿',
            '3': '活动稿',
        };
        $scope.params = {
            startTime: '',
            endTime: '',
        };
        $scope.data = {
            listData: [],
        };
        addChildRefresh();
    }

    function initData() {
        initDropDownList().then(function(){
            requestData();
        });
    }
    /**
     * [initDropDownList description] 初始化下拉菜单
     * @return {[type]} [description]
     */
    function initDropDownList() {
        var deffer = $q.defer();
        $scope.loadingPromise = initChannelsList().then(function(data) {
            var item = data.data;
            var allchannel = {
                name: "全部渠道",
                value: ''
            };
            $scope.status.channelsOptions.push(allchannel);
            for (var i = 0; i < item.length; i++) {
                var creatJSON = {};
                creatJSON.name = item[i].channelName;
                creatJSON.value = item[i].id;
                $scope.status.channelsOptions.push(creatJSON);
            }
            $scope.status.selectedChannel = angular.copy($scope.status.channelsOptions[0]);
            deffer.resolve();
        });
        return deffer.promise;
    }

    function initChannelsList() {
        var deferred = $q.defer();
        httpService.http("/mcnadmin/admin/auth/getAuthChannels.do", "", "post").then(function(data) {
            deferred.resolve(data);
        });
        return deferred.promise;
    }
    /**
     * [requestData description] 初始数据
     * @return {[type]} [description]
     */
    $scope.requestData = function() {
        requestData();
    };

    function requestData() {
        var params = {
            pubChannelId: $scope.status.selectedChannel.value,
            startTime: $scope.params.startTime,
            endTime: $scope.params.endTime,
            currPage: $scope.page.CURRPAGE,
            pageSize: $scope.page.PAGESIZE
        };
        $scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcArticle/auditArticleList.do", params, "post").then(function(data) {
            $scope.data.listData = data.data.ldata;
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
        });
    }
    /**
     * [queryByDropdown description] 筛选条件触发后请求数据
     * @param  {[type]} key   [description] 请求对象参数key
     * @param  {[type]} value [description] 请求对象值
     * @return {[type]}       [description] null
     */
    $scope.queryByDropdown = function() {
        $scope.params.startTime = $scope.status.startDate;
        $scope.params.endTime = $scope.status.endDate;
        requestData();
    };

    /**
     * [issueArticle description] 签发稿件
     * @param  {[type]} key   [description] 稿件的ID
     * @return {[type]}       [description] null
     */
    $scope.issueArticle = function(docId,channelId) {
        modalDialog.backConfirmModal("稿件签发", "确认签发此稿件？", function() {
            $scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcArticle/issueArticle.do", { articleId: docId,channelId:channelId }, "post").then(function(data) {
                modalDialog.alertType('', '签发成功', 'success');
                requestData();
            });
        });
    };
    /**
     * [backArticle description] 退回稿件
     * @param  {[type]} key   [description] 稿件的ID
     * @return {[type]}       [description] null
     */
    $scope.backArticle = function(docId,channelId) {
        backArticleService.backArticle().then(function(data) {
            $scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcArticle/backArticle.do", { articleId: docId, remark: data,channelId:channelId }, "post").then(function(data) {
                modalDialog.alertType('', '退回成功', 'success');
                requestData();
            });
        });

    };
    
    /**
     * [addChildRefresh description] 监听子页面保存，并刷新本身
     */
    function addChildRefresh() {
        window.addEventListener("storage", function(e) {
            if (e.key === "ls.refresh") {
                requestData();
            }
        }, false);
    };
    /**
    * [dateFormat description] 时间格式化
	* @return {[type]} [description]
	 */
	$scope.dateFormat = function(time) {
		return $filter("date")(time, "yyyy-MM-dd HH:mm:ss").toString();
	};
}]);